import type { BridgeApi } from '@/api/BridgeApi';
import type { RenderableContentArtifact } from '@/hooks/useContentArtifacts';
import { trackEvent } from '@/utils/fullstory';

export const closeChatPanelForArtifacts = (
	bridgeApi: BridgeApi,
	artifactIds: string[],
) => {
	const panel = bridgeApi.user_state?.chat_panel;
	if (panel?.panel_type === 'artifact' && artifactIds.includes(panel.item_id)) {
		bridgeApi.sendAction({ type: 'do_close_chat_panel' });
	}
};

export const dismissDeletedArtifact = (
	bridgeApi: BridgeApi,
	artifactId: string,
) => {
	bridgeApi.sendAction({
		type: 'do_navigate_to_content_detail_page',
		artifact_id: null,
	});

	closeChatPanelForArtifacts(bridgeApi, [artifactId]);
};

// Each content type reports its deletion under its own event name, and posts key
// the id as post_id while everything else uses artifact_id. Emitting one name for
// all of them would merge three separate funnels in the analytics dashboards.
const DELETE_EVENT_BY_TYPE: Record<
	RenderableContentArtifact['type'],
	{ name: string; idKey: 'post_id' | 'artifact_id' }
> = {
	instagram_post: { name: 'Content Post Deleted', idKey: 'post_id' },
	digital_ad: { name: 'Digital Ad Deleted', idKey: 'artifact_id' },
	email_html: { name: 'Content Email Deleted', idKey: 'artifact_id' },
	email_plaintext: { name: 'Content Email Deleted', idKey: 'artifact_id' },
};

export const trackArtifactDeleted = (artifact: RenderableContentArtifact) => {
	const { name, idKey } = DELETE_EVENT_BY_TYPE[artifact.type];
	trackEvent(name, { [idKey]: artifact.id });
};
